import { render, staticRenderFns } from "./ReMapLocation.vue?vue&type=template&id=57b98084&scoped=true"
import script from "./ReMapLocation.vue?vue&type=script&lang=js"
export * from "./ReMapLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b98084",
  null
  
)

export default component.exports